import { FC } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';

const Footer: FC = () => {
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterLogo>Matt Barbour</FooterLogo>
          <FooterText>
            Selected personal projects with demos and source on GitHub.
          </FooterText>
          <SocialRow>
            <SocialLink href="https://www.linkedin.com/in/matt-barbour-700bb57" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedinIn} />
            </SocialLink>
            <SocialLink href="https://github.com/barbourshop" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FontAwesomeIcon icon={faGithub} />
            </SocialLink>
          </SocialRow>
        </FooterContent>
      </div>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: #2c3e50;
  color: #ecf0f1;
  padding: 3rem 0;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const FooterLogo = styled.h2`
  font-family: var(--font-primary);
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #ffffff;
`;

const FooterText = styled.p`
  font-family: var(--font-primary);
  font-size: 1rem;
  margin-bottom: 1.5rem;
  color: #bdc3c7;
  max-width: 600px;
`;

const SocialRow = styled.div`
  display: flex;
  gap: 1.25rem;
  align-items: center;
  justify-content: center;
`;

const SocialLink = styled.a`
  color: #ecf0f1;
  font-size: 1.5rem;
  transition: color 0.2s ease;

  &:hover {
    color: #3498db;
  }
`;

export default Footer;
